/**
 * Tipagens para integração com Shaka Player
 * export interface ShakaStorageInstance {
  configure(config: ShakaPlayerConfig): void;
  store(uri: string, metadata: unknown): ShakaAbortableOperation<ShakaStore>;
  list(): Promise<ShakaStore[]>;
  remove(uri: string): Promise<void>;
  cancel(): Promise<void>;
}

export interface ShakaAbortableOperation<T> {
  promise: Promise<T>;
  abort(): Promise<void>;
}ipagens fornecem uma interface TypeScript segura para trabalhar com o Shaka Player
 */

// Interface global para Shaka Player (biblioteca JavaScript)
export interface ShakaGlobal {
  polyfill: {
    installAll(): void;
  };
  Player: {
    new (): ShakaPlayerInstance; // Construtor sem parâmetros (recomendado)
    new (element: HTMLVideoElement): ShakaPlayerInstance; // Construtor legado (deprecado)
    isBrowserSupported(): boolean;
  };
  ui: {
    Overlay: {
      new (
        player: ShakaPlayerInstance,
        container: HTMLElement,
        video: HTMLVideoElement
      ): void;
    };
  };
  offline: {
    Storage: {
      new (player: ShakaPlayerInstance | null): ShakaStorageInstance;
    };
  };
}

export interface ShakaPlayerInstance {
  addEventListener(
    type: string,
    listener: (event: ShakaErrorEvent) => void
  ): void;
  removeEventListener(
    type: string,
    listener: (event: ShakaErrorEvent) => void
  ): void;
  attach(videoElement: HTMLVideoElement): Promise<void>; // Método recomendado para anexar elemento
  load(uri: string): Promise<void>;
  destroy(): Promise<void>;
  isDestroyed?: boolean;
}

// Interface para operação abortável do Shaka Player
export interface IAbortableOperation<T = unknown> {
  promise: Promise<T>;
  abort(): Promise<void>;
}

export interface ShakaStorageInstance {
  configure(config: ShakaPlayerConfig): void;
  store(uri: string, metadata: unknown): IAbortableOperation<ShakaStore>;
  list(): Promise<ShakaStore[]>;
  remove(uri: string): Promise<void>;
  cancel(): Promise<void>;
}

export enum EOfflineStorageVideoType {
  serie = 'serie',
  video = 'video'
}

export interface OfflineStorageMetadata {
  id: string;
  title: string;
  type: EOfflineStorageVideoType;
  thumbnail?: string;
  serie?: {
    id: string;
    title: string;
    thumbnail?: string;
  };
}

export interface ShakaStore {
  duration: number;
  expiration: number;
  isIncomplete: boolean;
  offlineUri: string;
  originalManifestUri: string;
  size: number;
  appMetadata: OfflineStorageMetadata;
}

export interface ShakaPlayerConfig {
  offline?: {
    progressCallback?: (content: unknown, progress: number) => void;
  };
}

export interface ShakaErrorEvent {
  detail?: ShakaErrorDetail;
  type: string;
  bubbles: boolean;
  cancelable: boolean;
  defaultPrevented: boolean;
  timeStamp: number;
}

export interface ShakaErrorDetail {
  category: number;
  code: number;
  data?: unknown[];
  handled?: boolean;
  message: string;
  severity: number;
  stack?: string;
}

// Declaração global do shaka
declare global {
  const shaka: ShakaGlobal;
}
